<template>
  <BackNav :title="$t('setting.avatarTitle')" />
  <van-uploader :after-read="afterRead" />
</template>

<script setup>
import BackNav from '@/components/BackNav';
import { useRouter } from 'vue-router';
const router = useRouter();
const afterRead = (file) => {
  // 此时可以自行将文件上传至服务器
  console.log(file);
  router.push('/setting');
};
</script>

<style lang="scss" scoped></style>
